import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const AUDIO_SETTINGS_EVENT_NAMES = {
  TOGGLE_SOUND: 'sound_notifications_turned_csp',
  CHANGE_AUDIO_TONE: 'audio_tone_changed_csp',
  AUDIO_TONE_PREVIEWED: 'audio_tone_previewed_csp',
};

export const trackToggleSoundOnOff = (irpVersion, soundOnStatus) => {
  const soundStatus = soundOnStatus ? 'Off' : 'On';
  gspx.trackEvent({
    name: AUDIO_SETTINGS_EVENT_NAMES.TOGGLE_SOUND,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.ADMIN,
    additionalKeys: {
      legacy_category: 'Admin',
      legacy_name: `Sound Notifications for alerts were turned ${soundStatus} in CSP`,
      Category: 'Admin Settings',
      'Launched date': new Date(),
      irpVersion,
    },
  });
};

export const trackChangeAudioTone = irpVersion => {
  gspx.trackEvent({
    name: AUDIO_SETTINGS_EVENT_NAMES.CHANGE_AUDIO_TONE,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.ADMIN,
    additionalKeys: {
      legacy_category: 'Admin',
      legacy_name: 'The Audio Tone for alerts was changed in CSP',
      Category: 'Admin Settings',
      'Launched date': new Date(),
      irpVersion,
    },
  });
};

export const trackAudioTonePreviewed = (irpVersion, toneName) => {
  gspx.trackEvent({
    name: AUDIO_SETTINGS_EVENT_NAMES.AUDIO_TONE_PREVIEWED,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.ADMIN,
    additionalKeys: {
      legacy_category: 'Admin',
      legacy_name: `The ${toneName} Audio Tone was pre-viewed in CSP`,
      Category: 'Admin Settings',
      'Launched date': new Date(),
      irpVersion,
    },
  });
};
